module.exports = __webpack_public_path__ + "static/img/anxun63.aec17bfc.jpg";